import { Bike, Box, Car, Home, Scale, Ship, Truck, Users } from 'lucide-react';

import type { RiskObjectType } from '../types';

type Props = {
  type: RiskObjectType | undefined | string;
  className?: string | undefined;
};

export default function RiskObjectIcon({ type, className }: Props) {
  switch (type) {
    case 'CAR':
      return <Car className={className} />;
    case 'RESIDENCE':
      return <Home className={className} />;
    case 'BICYCLE':
    case 'TWO_WHEELER':
      return <Bike className={className} />;
    case 'BOAT':
      return <Ship className={className} />;
    case 'LEGAL':
      return <Scale className={className} />;
    case 'PARTY_GROUP':
    case 'FAMILY':
      return <Users className={className} />;
    case 'TRAILER':
    case 'SEMI_TRAILER':
      return <Truck className={className} />;
    default:
      return <Box className={className} />;
  }
}
